<template>
  <div class="image-picker" :class="{ 'is-view-only': !isEditMode }">
    <label class="image-picker__label">{{ $t('common.image') }}</label>

    <div class="image-picker__preview">
      <img v-if="isImageUrlLoaded" :src="imageUrl" :alt="$t('common.image')" />
      <img v-else :src="require('@/assets/placeholder.png')" :alt="$t('common.image')" />
    </div>

    <div v-if="isEditMode" class="image-picker__controls">
      <b-field class="file" :class="{ 'has-name': !!imageFile }">
        <b-upload v-model="imageFile" class="file-label" accept=".jpg, .jpeg, .png"
                  @input="onImageFileSelected">
          <span class="file-cta">
            <b-icon class="file-icon" icon="upload"></b-icon>
            <span class="file-label">{{ $t('user-details-view.select-image-button') }}</span>
          </span>
          <span class="file-name" v-if="imageFile">{{ imageFile.name }}</span>
        </b-upload>
        <b-button v-if="isImageFileSelected" type="is-danger" icon-left="delete"
                  @click="onImageFileRemoveSelected" />
      </b-field>
      <p v-if="!imageFile" class="image-picker__hint">
        {{ $t('user-details-view.image-allowed-size') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImagePicker",
  props: {
    isEditMode: { type: Boolean },
    imageUrl: { type: String }
  },
  data() {
    return {
      imageFile: null
    }
  },
  methods: {
    onImageFileSelected() {
      this.$emit("onImageFileSelected", this.imageFile)
    },
    onImageFileRemoveSelected() {
      this.imageFile = null
      this.$emit("onImageFileRemoveSelected")
    }
  },
  computed: {
    isImageFileSelected() {
      return this.imageFile !== null && this.imageFile !== undefined && this.imageFile !== "";
    },
    isImageUrlLoaded() {
      return this.imageUrl !== null && this.imageUrl !== undefined && this.imageUrl !== "";
    }
  },
  watch: {
    imageUrl: function () {
      if (this.imageUrl === null || this.imageUrl === undefined || this.imageUrl === "") {
        this.imageFile = null
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/tokens";

.image-picker {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-start;
}

.image-picker__label {
  font-size: 12.5px;
  font-weight: 600;
  color: $omx-ink-700;
}
.image-picker.is-view-only .image-picker__label {
  font-size: 11px;
  letter-spacing: .08em;
  text-transform: uppercase;
  color: $omx-ink-500;
}

.image-picker__preview {
  width: 200px;
  height: 200px;
  border: 1px solid $omx-ink-100;
  border-radius: $omx-radius-md;
  background: $omx-ink-50;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
}

.image-picker__controls {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.image-picker__hint {
  margin: 0;
  font-size: 12px;
  color: $omx-ink-500;
}
</style>
